export default "__VITE_ASSET__D97b_eu___"